import React from 'react'
import { Icon } from '../Icon'
import { Tooltip } from '../Tooltip'
import * as S from './styled'
import type { TagProps } from './types'

export const Tag = ({
  label,
  appearance = 'default',
  icon,
  tooltip,
  size = 'small',
  hoverable = false,
  display = 'flex',
}: TagProps) => {
  const tag = (
    <S.Container $appearance={appearance} $size={size} $hoverable={hoverable} $display={display}>
      <span>{label}</span>
      {icon && <Icon component={icon} height={10} />}
    </S.Container>
  )

  if (!tooltip) {
    return tag
  }

  return (
    <Tooltip reference={tag} placement="top" strategy="fixed">
      {tooltip}
    </Tooltip>
  )
}
